/* eslint-disable jsx-a11y/control-has-associated-label */
// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

interface Props {
  formValues: any;
  fileId: string;
  fileName: string;
  download: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Function to generate a form component
 *
 * @param props properties of the component
 * @returns jsx element with the form
 */
export default function Form(props: Props): JSX.Element {
  const { uploading } = props.formValues;
  const { fileName, fileId } = props;

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Version</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={props.formValues.ver}
            name="ver"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
      <br />
      <div className="row">
        {props.formValues.id && (
          <div className="col-6">
            <label className="label">
              <b>Old File</b>
            </label>
            <div className="cl-element btn-select2-addon">
              <input
                className="inputNew"
                style={{ width: '60%' }}
                type="text"
                size={50}
                value={props.formValues.file || ''}
                readOnly
              />
              &nbsp;&nbsp;
              <button
                type="button"
                style={{ right: 'unset' }}
                className="btn btn-default"
                onClick={props.download}
              >
                Download
              </button>
            </div>
          </div>
        )}
        <div className="col-6">
          <div>
            <label className="label">
              <b>Selected File</b>
            </label>
            <div className="input input-file">
              <span className="button">
                <input
                  type="file"
                  id={fileId}
                  name="file"
                  onChange={props.onChange}
                  required={!props.formValues.id}
                  accept=".bin"
                />
                Browse
                <label>&nbsp;&nbsp;{props.formValues.id ? '' : '*'}</label>
              </span>
              <input type="text" id={fileName} placeholder="Include some files" readOnly />
            </div>
          </div>
          <div className="file-upload">
            {uploading && (
              <div className="smart-form">
                <h4>Uploading file...</h4>
                <div className="progress progress-sm progress-striped active">
                  <div className="progress-bar" role="progressbar" style={{ width: '100%' }} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </fieldset>
  );
}
